module.exports = __webpack_public_path__ + "media/images/emblems/Tolochenaz-coat_of_arms-b9f1f992cfe2d3e972a315202f57ec22.svg";